import { Component, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { SignUpService } from "../Service/SignUp.Service";
import { SignUpModel } from "../../model/index"
import { Title } from '@angular/platform-browser';
import { ModalComponent } from "../../shared/modeldialog/index";
declare var require: any;

@Component({
    selector: 'MentisSoft-SignUp',
    template: require('../Template/SignUp.template.html'),
    styles: [require('../Template/SignUp.css')]
})

export class SignUpComponent {
    @ViewChild("viewModelPopup") viewModelPopup: ModalComponent;
    constructor(private router: Router, private route: ActivatedRoute, private _SignUpService: SignUpService, private _titleService: Title
    ) {
    }
    loading = false;
    signInfo: SignUpModel = new SignUpModel();
    errMsg: string = "";
    SuccessSignup: Boolean = false;
    IsEmail: Boolean = false;
    IsPatientId: Boolean = false;
    IsDefaultPassword: Boolean = false;
    IsUserName: Boolean = false;
    IsPassword: Boolean = false;
    IsConfirmPassword: Boolean = false;
	successMsg : string = "";
    ngAfterViewInit() {
        $('#overlay').hide();
    }
    SignUp(event) {
        this.loading = true;
        if (this.signInfo !== null && (this.signInfo.email !== undefined && this.signInfo.email !== "" && this.signInfo.email !== null)
            && this.signInfo.patientid !== undefined && this.signInfo.patientid !== null && this.signInfo.patientid !== ""
            && this.signInfo.defaultpassword !== undefined && this.signInfo.defaultpassword !== null && this.signInfo.defaultpassword !== ""
            && this.signInfo.username !== undefined && this.signInfo.username !== null && this.signInfo.username !== ""
            && this.signInfo.password !== undefined && this.signInfo.password !== null && this.signInfo.password !== ""
            && this.signInfo.ConfirmPassword !== undefined && this.signInfo.ConfirmPassword !== null && this.signInfo.ConfirmPassword !== ""){
            if (this.signInfo.password == this.signInfo.ConfirmPassword) {
                this._SignUpService.validCredentials(this.signInfo)
                    .subscribe(
                    p => {
                        this.loading = false;
                        if (p.IsValid && p.Authentication == "SUCCESS") {
                            this.viewModelPopup.open();
                            this.SuccessSignup = true;
                            this.successMsg = "You have Successfully Signed up to Patient Portal.";
                        }

                        else {
                            this.viewModelPopup.close();
                            this.SuccessSignup = false;
                            this.errMsg = p.Authentication;
                        }
                    }
                    ,
                    err => {	
						this.viewModelPopup.close();					
                        this.SuccessSignup = false;
                        this.loading = false;
                        this.errMsg = "The Information You are Provided is Not Matching, Please Verify the Information!Invalid Username or Password!";
                        console.log("Please enter usernmae/password");
                    });
            }
            else {
				this.viewModelPopup.close();
                this.SuccessSignup = false;
                this.loading = false;
                this.errMsg = "Password and Confirm Password should be matched";
                console.log("New password and Confirm Password should be matched");
            }
        }

        else {
            this.SuccessSignup = false;
            this.loading = false;
            if (this.signInfo == null || this.signInfo.email == undefined || this.signInfo.email == "" || this.signInfo.email == null
                || this.signInfo.patientid == undefined || this.signInfo.patientid == null || this.signInfo.patientid == ""
                || this.signInfo.defaultpassword == undefined || this.signInfo.defaultpassword == null || this.signInfo.defaultpassword == ""
                || this.signInfo.username == undefined || this.signInfo.username == null || this.signInfo.username == ""
                || this.signInfo.password == undefined || this.signInfo.password == null || this.signInfo.password == ""
                || this.signInfo.ConfirmPassword == undefined || this.signInfo.ConfirmPassword == null || this.signInfo.ConfirmPassword == "") {
                if (this.signInfo == null || this.signInfo.email == undefined || this.signInfo.email == "" || this.signInfo.email == null)
                    this.IsEmail = true;
                else
                    this.IsEmail = false;
                if (this.signInfo.patientid == undefined || this.signInfo.patientid == null || this.signInfo.patientid == "")
                    this.IsPatientId = true;
                else
                    this.IsPatientId = false;
                if (this.signInfo.defaultpassword == undefined || this.signInfo.defaultpassword == null || this.signInfo.defaultpassword == "")
                    this.IsDefaultPassword = true;
                else
                    this.IsDefaultPassword = false;
                if (this.signInfo.username == undefined || this.signInfo.username == null || this.signInfo.username == "")
                    this.IsUserName = true;
                else
                    this.IsUserName = false;
                if (this.signInfo.password == undefined || this.signInfo.password == null || this.signInfo.password == "")
                    this.IsPassword = true
                else
                    this.IsPassword = false;
                if (this.signInfo.ConfirmPassword == undefined || this.signInfo.ConfirmPassword == null || this.signInfo.ConfirmPassword == "")
                    this.IsConfirmPassword = true;
                else
                    this.IsConfirmPassword = false;
                this.errMsg = "Please enter the required mandatory(*) filed.";
            }
            console.log("Error while validating- Enter username/ pwd...");
        }
    }

    logBacktoLogin(event) {
        this.router.navigate(["/Login"]);
    }

}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/SignUp/Component/SignUp.Component.ts